import { StatusPedido as Status, StatusPedidoDesc as Desc, StatusContrato, StatusAnaliseCadastral } from './constants'
import { StatusAlocacoes } from './status_alocacoes'

const colorEmProcesso = 'info'
const colorNeutro = 'neutral'
const colorSucesso = 'success'
const colorAlerta = 'warning'
const colorErro = 'error'

const iconEmProcesso = 'mdi-timer-sand'
const iconNeutro = 'mdi-file-edit-outline'
const iconSucesso = 'mdi-checkbox-marked-circle-outline'
const iconAlerta = 'mdi-alert-outline'
const iconErro = 'mdi-close-circle-outline'
const iconEmEspera = 'mdi-folder-off-outline'

export const ListaStatusPedido = {
  [Status.Pago]: {
    label: Desc[Status.Pago],
    style: { backgroundColor: `${colorSucesso}`, color: `${colorSucesso}`, icon: `${iconSucesso}` }
  },
  [Status.Enviado]: {
    label: Desc[Status.Enviado],
    style: { backgroundColor: `${colorSucesso}`, color: `${colorSucesso}`, icon: `${iconSucesso}` }
  },
  [Status.AguardandoPagamento]: {
    label: Desc[Status.AguardandoPagamento],
    style: { backgroundColor: `${colorEmProcesso}`, color: `${colorEmProcesso}`, icon: `${iconEmProcesso}` }
  },
  [Status.AguardandoFormaPagamento]: {
    label: Desc[Status.AguardandoFormaPagamento],
    style: { backgroundColor: `${colorAlerta}`, color: `${colorAlerta}`, icon: `${iconAlerta}` }
  },
  [Status.Finalizado]: {
    label: Desc[Status.Finalizado],
    style: { backgroundColor: `${colorEmProcesso}`, color: `${colorEmProcesso}`, icon: `${iconEmProcesso}` }
  },
  [Status.Rascunho]: {
    label: Desc[Status.Rascunho],
    style: { backgroundColor: `${colorNeutro}`, color: `${colorNeutro}`, icon: `${iconNeutro}` }
  },
  [Status.Cancelado]: {
    label: Desc[Status.Cancelado],
    style: { backgroundColor: `${colorErro}`, color: `${colorErro}`, icon: `${iconErro}` }
  },
  'C': {
    label: Desc[Status.Cancelado],
    style: { backgroundColor: `${colorErro}`, color: `${colorErro}`, icon: `${iconErro}` }
  },
  [Status.Bloqueado]: {
    label: Desc[Status.Bloqueado],
    style: { backgroundColor: `${colorAlerta}`, color: `${colorAlerta}`, icon: `${iconAlerta}` }
  },
  InformacoesComplementares: {
    label: 'Enviando informações complementares',
    style: { backgroundColor: `${colorEmProcesso}`, color: `${colorEmProcesso}`, icon: `${iconEmProcesso}` }
  },
  AguardandoPagamentoCliente: {
    label: Desc.AguardandoPagamentoCliente,
    style: { backgroundColor: `${colorAlerta}`, color: `${colorAlerta}`, icon: `${iconAlerta}` }
  },
  [Status.AguardandoAssinaturaContrato]: {
    label: Desc[Status.AguardandoAssinaturaContrato],
    style: { backgroundColor: `${colorAlerta}`, color: `${colorAlerta}`, icon: `${iconAlerta}` }
  },
  [Status.AguardandoAssinaturaContratoAlocacao]: {
    label: Desc[Status.AguardandoAssinaturaContratoAlocacao],
    style: { backgroundColor: `${colorAlerta}`, color: `${colorAlerta}`, icon: `${iconAlerta}` }
  },
  [Status.FalhaAlocacao]: {
    label: Desc[Status.FalhaAlocacao],
    style: { backgroundColor: `${colorErro}`, color: `${colorErro}`, icon: `${iconErro}` }
  },
  Falha: {
    label: 'Falha ao enviar dados complementares',
    style: { backgroundColor: `${colorErro}`, color: `${colorErro}`, icon: `${iconErro}` }
  },
  [Status.SituacaoInicial]: {
    label: Desc[Status.SituacaoInicial],
    style: { backgroundColor: `${colorEmProcesso}`, color: `${colorEmProcesso}`, icon: `${iconEmProcesso}` }
  },
  [Status.AguardandoRetorno]: {
    label: Desc[Status.AguardandoRetorno],
    style: { backgroundColor: `${colorEmProcesso}`, color: `${colorEmProcesso}`, icon: `${iconEmProcesso}` }
  },
  [Status.RetornoProcessado]: {
    label: Desc[Status.RetornoProcessado],
    style: { backgroundColor: `${colorEmProcesso}`, color: `${colorEmProcesso}`, icon: `${iconEmProcesso}` }
  },
  [Status.AprovadoAnaliseCredito]: {
    label: Desc[Status.AprovadoAnaliseCredito],
    style: { backgroundColor: `${colorEmProcesso}`, color: `${colorEmProcesso}`, icon: `${iconEmProcesso}` }
  },
  [Status.ReprovadoAnaliseCredito]: {
    label: Desc[Status.ReprovadoAnaliseCredito],
    style: { backgroundColor: `${colorErro}`, color: `${colorErro}`, icon: `${iconErro}` }
  },
  [Status.AguardandoDecisaoAnaliseCredito]: {
    label: Desc[Status.AguardandoDecisaoAnaliseCredito],
    style: { backgroundColor: `${colorAlerta}`, color: `${colorAlerta}`, icon: `${iconAlerta}` }
  },
  // status da pendência
  [Status.PendenteAnaliseCredito]: {
    label: Desc[Status.PendenteAnaliseCredito],
    style: { backgroundColor: `${colorEmProcesso}`, color: `${colorEmProcesso}`, icon: `${iconEmProcesso}` }
  },
  [Status.AGENDADO_GERAR_PROPOSTA_CARRINHO]: {
    label: Desc[Status.AGENDADO_GERAR_PROPOSTA_CARRINHO],
    style: { backgroundColor: `${colorNeutro}`, color: `${colorNeutro}`, icon: `${iconEmProcesso}` }
  },
  [Status.GERANDO_PROPOSTA_CARRINHO]: {
    label: Desc[Status.GERANDO_PROPOSTA_CARRINHO],
    style: { backgroundColor: `${colorNeutro}`, color: `${colorNeutro}`, icon: `${iconEmProcesso}` }
  },
  [Status.ERRO_GERAR_PROPOSTA_CARRINHO]: {
    label: Desc[Status.ERRO_GERAR_PROPOSTA_CARRINHO],
    style: { backgroundColor: `${colorErro}`, color: `${colorErro}`, icon: `${iconErro}` }
  }
}

export const ListaStatusContrato = {
  [StatusContrato.ContratoPendente]: {
    style: { backgroundColor: `${colorEmProcesso}`, color: `${colorEmProcesso}`, icon: `${iconEmProcesso}` }
  },
  [StatusContrato.ContratoCancelado]: {
    style: { backgroundColor: `${colorErro}`, color: `${colorErro}`, icon: `${iconErro}` }
  },
  [StatusContrato.ContratoAssinado]: {
    style: { backgroundColor: `${colorSucesso}`, color: `${colorSucesso}`, icon: `${iconSucesso}` }
  },
  [StatusContrato.ContratoFalha]: {
    style: { backgroundColor: `${colorErro}`, color: `${colorErro}`, icon: `${iconErro}` }
  },
  [StatusContrato.ContratoRejeitado]: {
    style: { backgroundColor: `${colorAlerta}`, color: `${colorAlerta}`, icon: `${iconAlerta}` }
  },
  [StatusContrato.ContratoEmEspera]: {
    style: { backgroundColor: `${colorNeutro}`, color: `${colorNeutro}`, icon: `${iconEmEspera}` }
  }
}

export const ListaStatusAnaliseCadastral = {
  [StatusAnaliseCadastral.Aprovado]: {
    style: { backgroundColor: `${colorSucesso}`, color: `${colorSucesso}`, icon: `${iconSucesso}` }
  },
  [StatusAnaliseCadastral.EmAnalise]: {
    style: { backgroundColor: `${colorEmProcesso}`, color: `${colorEmProcesso}`, icon: `${iconEmProcesso}` }
  },
  [StatusAnaliseCadastral.Pendente]: {
    style: { backgroundColor: `${colorNeutro}`, color: `${colorNeutro}`, icon: `${iconEmEspera}` }
  },
  [StatusAnaliseCadastral.Reprovado]: {
    style: { backgroundColor: `${colorErro}`, color: `${colorErro}`, icon: `${iconErro}` }
  }
}

export const ListaStatusAlocacao = {
  [StatusAlocacoes.Alocado]: {
    style: { backgroundColor: `${colorSucesso}`, color: `${colorSucesso}`, icon: `${iconSucesso}` }
  },
  [StatusAlocacoes.NaoAlocado]: {
    style: { backgroundColor: `${colorNeutro}`, color: `${colorNeutro}`, icon: `${iconNeutro}` }
  },
  [StatusAlocacoes.FalhaAlocacao]: {
    style: { backgroundColor: `${colorErro}`, color: `${colorErro}`, icon: `${iconErro}` }
  },
  [StatusAlocacoes.Cancelada]: {
    style: { backgroundColor: `${colorErro}`, color: `${colorErro}`, icon: `${iconErro}` }
  }
}

export const icones_status_hashmap = {
  [StatusContrato.ContratoCancelado]: 'close',
  [StatusContrato.ContratoFalha]: 'error',
  [StatusContrato.ContratoAssinado]: 'check',
  [StatusContrato.ContratoPendente]: 'hourglass_empty',
  [StatusContrato.ContratoRejeitado]: 'not_interested'
}
